import { IndicationRequestParams, IndicationSearchRequestQuery } from '@lio/api-types';

export const indicationQueryKey = {
  get: ['indication'] as const,
  getSummary: (params?: IndicationRequestParams) => ['indication', 'summary', params] as const,
  getWithParams: (params: IndicationRequestParams) => [...indicationQueryKey.get, params] as const,
  search: ['indications'] as const,
  searchWithParams: (params: IndicationSearchRequestQuery) => [...indicationQueryKey.search, params] as const,
  getIndicationItems: (indicationId: string) =>
    [...indicationQueryKey.getWithParams({ indicationId }), 'indication-item'] as const,
};
